/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import MobileNavButton from './MobileNavButton';

const MobileMenuItem = (props) => {
  const { targetInfo, itemClick, ...reset } = props;
  let active = null;
  if (targetInfo.active) {
    active = true;
  }
  return (
    <MobileNavButton
      onMouseDown={() => setTimeout(() => itemClick(targetInfo), 500)}
      active={active}
      {...reset}
    />
  );
};
MobileMenuItem.propTypes = {
  targetInfo: PropTypes.object,
  style: PropTypes.object,
  itemClick: PropTypes.func,
};
MobileMenuItem.defaultProps = {
  targetInfo: {},
  style: {},
  itemClick: () => {},
};
export default MobileMenuItem;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/MobileNavigation/MobileMenuItem.jsx